import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { WorkerAvatar } from "@src/appV2/redesign/components/WorkerAvatar";
import { formatDistanceToNow } from "date-fns";

interface WorkplaceReviewCommentAuthorInfoProps {
  workerName: string;
  profilePictureUrl?: string;
  isLoadingProfilePicture?: boolean;
  createdAt: Date;
}

export function WorkplaceReviewCommentAuthorInfo(props: WorkplaceReviewCommentAuthorInfoProps) {
  const { workerName, profilePictureUrl, isLoadingProfilePicture, createdAt } = props;

  return (
    <Stack direction="row" spacing={3}>
      <WorkerAvatar
        profilePictureUrl={profilePictureUrl}
        isLoading={isLoadingProfilePicture}
        size="small"
      />

      <Box>
        <Text semibold variant="body2">
          {workerName}
        </Text>

        <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
          {formatDistanceToNow(createdAt)} ago
        </Text>
      </Box>
    </Stack>
  );
}
